'use strict';

import acceptedCookiePolicy from "../../components/onetrust/cookiePolicy.js";

const gatedWistiaChannelClass = 'wistia-channel-is-gated';
const maxViews = 2;
let latestViewedVideo = '';
let wistiaWatchedVideos = 0;
let showGatedForm = true;

const openGatedForm = () => {
    document.getElementById('show-wistia-channel-gated-form').click();
};
const bodyClassesIncludeWistiaGated = () => {
    return document.body.className.includes(gatedWistiaChannelClass);
}
const removeGatedClass = () => {
    if(bodyClassesIncludeWistiaGated()) {
        document.body.classList.remove(gatedWistiaChannelClass);
    }
}

const addGatedClass = () => {
    if(!bodyClassesIncludeWistiaGated()) {
        document.body.classList.add(gatedWistiaChannelClass);
    }
};

const onClickChannelBanner = () => {
    const wistiaChannelBanners = document.querySelectorAll('[data-component="wistia-channel-banner"]')

    for(const wistiaChannel of wistiaChannelBanners) {
        wistiaChannel.addEventListener('click', () => {
            if(showGatedForm && wistiaWatchedVideos >= maxViews) {
                addGatedClass();
            }
        });
    }
};
const removeGatedOnCloseFormWithModal = () => {
    /*
    * When the form modal close, show the video the user wanted to see before the form opened
    */
    document.addEventListener('close-modal', () => {
        showGatedForm = false;

        wistiaWatchedVideos = 0;

        removeGatedClass();
        document.body.removeAttribute('style');

        if(latestViewedVideo && latestViewedVideo !== '') {
            setTimeout(() => {
                document.querySelector(`[href="${latestViewedVideo}"]`)?.click();
            }, 300);
        }
    });
};

const closeChannelAndShowForm = () => {
    document.querySelector('.w-popover-overlay__close-button')?.click();

    setTimeout(() => {
        openGatedForm();
    }, 150);
};

const countViewsOnVideoPlay = () => {
    if(wistiaWatchedVideos < maxViews) {
        /*
        * Channel API
        * https://docs.wistia.com/docs/channel-embeds#channel-api-usage
        */
        window._wcq = window._wcq || [];
        window._wcq.push({
            id: "_all",
            onHasData: function (channel) {
                channel.on("currentvideochange", function (videoID) {
                    /*
                    * Execute only once
                    * https://docs.wistia.com/docs/javascript-player-api#alert-on-play-just-once
                    */
                    const executeOnceOnPlay = () => {
                        if(showGatedForm && wistiaWatchedVideos < 2) {
                            wistiaWatchedVideos = wistiaWatchedVideos + 1;
                        }

                        Wistia.api(videoID).unbind("play", executeOnceOnPlay);
                    }

                    if (videoID) {
                        if(wistiaWatchedVideos >= maxViews) {
                            setTimeout(() => {
                                closeChannelAndShowForm();
                            }, 250);

                            return;
                        }

                        Wistia.api(videoID).bind("play", executeOnceOnPlay);
                    } else {
                        /*
                        * Run when the channel has been closed
                        */
                        if(wistiaWatchedVideos >= maxViews) {
                            addGatedClass();
                        }

                        latestViewedVideo = window.location.href;
                    }
                });
            }
        });
    }
};

/*
* Add Wistia Channel gated feature for Demo Hub only for now.
* coveo.com/en/demo-hub
*/
const isDemoHubPage = document.querySelector('html')?.dataset?.page === 'demo-hub';

if(isDemoHubPage) {
    acceptedCookiePolicy({
        ifNoTargetingCookies: () => {
            if(typeof Wistia !== 'undefined') {
                Wistia.consent(false);
            }
        }
    });

    countViewsOnVideoPlay();
    removeGatedOnCloseFormWithModal();
    onClickChannelBanner();
}